import { useMemo } from "react";
import { Col, Row } from "antd";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const TermsAndConditions: React.FC = () => {
  const navigate = useNavigate();
  const { legalName, websiteUrl, brokerAddress, supportEmail, supportPhone, brokerName } = useSelector((state: any) => state.theme);
  const tnc_content = [
    {
      title: 'Definitions',
      content: <ul>
            <li>“User”: Any individual or entity accessing or using the Services.</li>
            <li>“Services”: Technology-enabled insurance and wellness solutions provided by {brokerName}.</li>
            <li>“Platform Provider”: BharatSure, which hosts and operates the technology platform. </li>
            {websiteUrl && <li>“Website”: <a href={websiteUrl} target="_blank">{websiteUrl}</a></li>}
          </ul>
    },
    {
      title: 'Eligibility',
      content: <span>You must be at least 18 years old. Users under 18 may use Services only with parental or legal guardian consent.</span>
    },
    {
      title: 'User Responsibilities',
      content: <ul>
      <li>Provide accurate and truthful information during registration and use</li>
      <li>Keep login credentials secure and confidential</li>
      <li>Use Services only for lawful purposes</li>
      <li>Refrain from unauthorized access, misuse, or reselling of Services</li>
    </ul>
    },
    {
      title: 'Service Description',
      content: <ul>
      <li>{brokerName} provides insurance-related products and Services; BharatSure provides the technology platform.</li>
      <li>Insurance coverage, claims, and policy terms are governed by respective insurers.</li>
      <li>{brokerName} may modify, suspend, or discontinue any Service at its discretion.</li>
    </ul>
    },
    {
      title: 'Intellectual Property',
      content: <ul>
      <li>All content, designs, logos, and software are owned by {legalName} unless otherwise stated.</li>
      <li>Users may not copy, reproduce, distribute, or create derivative works without prior written consent.</li>
    </ul>
    },
    {
      title: 'Limitation of Liability',
      content: <span>{brokerName} and BharatSure shall not be liable for indirect, incidental, or consequential losses arising from use of Services, including business, financial, or data losses.</span>
    },
    {
      title: 'Privacy',
      content: <span>Use of Services is governed by our Privacy Policy</span>
    },
    {
      title: 'Indemnity',
      content: <span>You agree to defend, indemnify, and hold harmless {brokerName} and BharatSure from any claims, damages, or losses arising from your use of Services or violation of these Terms.</span>
    },
    ...brokerAddress ? [{
      title: 'Governing Law and Jurisdiction',
      content: <span>These Terms are governed by the laws of India. Courts in {brokerAddress?.split(',')?.slice(-3)?.[0]?.trim()} have exclusive jurisdiction over any disputes arising from these Terms.</span>
    }] : [],
    {
      title: 'Updates to Terms',
      content: <span>We may update these Terms periodically. Continued use of Services constitutes acceptance of the revised Terms.</span>
    },
    {
      title: 'Contact Information',
      content: <Row gutter={[0, 16]}>
        <Col span={24}>Legal Department</Col>
        {legalName && <Col span={24}>{legalName}</Col>}
        {brokerAddress && <Col span={24}>{brokerAddress}</Col>}
        {supportEmail && <Col span={24}>Email: {supportEmail}</Col>}
      </Row>
    },
  ]
  const lastUpdated = useMemo(() => {
    return new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }, []);
  const section = (index: number, title: string, content: React.ReactNode) => <Row key={index} gutter={[0, 16]}>
    <Col span={24} className="pp-subheading">{index + 1}. {title}</Col>
    <Col span={24} className="pp-text">{content}</Col>
  </Row>

  return <div className="pp-content pp-text">
    <Row gutter={[0, 32]}>
      <Row gutter={[0, 24]}>
        <Col span={24} className="pp-title">Terms and Conditions</Col>
        <Col span={24} className="pp-text" style={{ fontWeight: 500 }}>Last updated on {lastUpdated}</Col>
        <Col span={24} className="pp-text">
          These Terms & Conditions constitute a binding agreement between you and {legalName} (“{brokerName},” “we,” “us,” “our”) regarding the use of the website <a href={websiteUrl} target="_blank">{websiteUrl}</a> and associated applications and Services. The Services are powered by BharatSure (Safetynet Innovations Private Limited), which provides the technology platform for the Services.
          <br /> <br />
          For information on how we handle your personal data, please see our <span onClick={() => navigate('/privacy-policy')} style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>Privacy Policy</span>.
          <br /> <br />
          By accessing or using our Services, you agree to be bound by these Terms.
        </Col>
      </Row>
      <Row gutter={[0, 24]}>
        {tnc_content.map((item, index) => section(index, item.title, item.content))}
      </Row>
    </Row>
  </div>;
};

export default TermsAndConditions;